import type { DeepPartial } from '@luna/utils-ts';

import type { Misc } from '../../types/Misc';

export const miscROFeatureConfig: DeepPartial<Misc> = {
    addTokenToDownloadPayload: true,
    externalPlatformTargetClientId: 'bcrbroker',
};
